import { AgentsQuery, useAgentsQuery } from '../../../shared';
import { useEffect, useState } from 'react';
import { gql } from '@apollo/client';
import { AgentField, AgentSortDirection, PageInput, SortDirection } from '@coverright/data-access/types/enrollment';
import { enrollmentApolloClient } from '@coverright/data-access/apollo-clients';

export type Agent = AgentsQuery['agents']['data'][0] & {gmail?: boolean};

export const useAgents = (page: PageInput, enabled?: string, sort?: {field: AgentField, direction: SortDirection}) => {
  const [agents, setAgents] = useState<Agent[]>([]);
  const {loading, data, refetch} = useAgentsQuery({
    variables: {
      page,
      sort: sort ? { field: sort.field, direction: sort.direction.toUpperCase() as AgentSortDirection } : undefined,
      filter: {enabled: enabled ? enabled === 'true' : undefined }
    }
  })

  useEffect(() => {
    if (data?.agents.data.length) {
      setAgents(data?.agents.data || []);
      decorate(data?.agents.data).then(setAgents)
    }
  }, [data?.agents]);

  return {agents, loading, total: data?.agents.totalElements || 0, refetch}
}

const decorate = async (agents: Agent[]): Promise<Agent[]> => {
  const query = `
    query {
      ${agents.map((a, i) => 'a' + i + `: isAgentGmailSetUp(agentId: "${a.id}")`).join(' ')}
    }
  `;

  const setup = await enrollmentApolloClient.query({
    fetchPolicy: 'no-cache',
    query: gql(query)
  }).then(res => res.data || {});

  return agents.map((a, i) => ({...a, gmail: setup['a' + i]}));
}
